<template>
  <el-card class="box-card" v-loading="isLoading">
    <div slot="header" class="clearfix">
      <span class="form-header">Pergunta - Novo</span>
    </div>
    <div class="row">
      <div class="col">
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item label="Descrição" prop="field" v-bind:error="errors.descricao">
            <el-input v-model="form.descricao" size="medium" autosize></el-input>
          </el-form-item>
          <el-form-item label="Grupo" prop="grupo" :error="errors.pergunta_grupo_id">
            <el-select v-model="form.pergunta_grupo_id" placeholder="Grupo">
              <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="bottom clearfix">
            <el-button type="primary" style="float: right;margin: 20px" @click="salvar()">Salvar
            </el-button>
            <el-button type="danger" style="float: right;margin: 20px" @click="cancelar()">Cancelar</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </el-card>

</template>

<script>
  import ElCard from "element-ui/packages/card/src/main";
  import {mapActions, mapState} from 'vuex'
  import ElForm from "element-ui/packages/form/src/form";
  import * as utils from '../../domain/utils'
  export default {
    components: {
      ElForm,
      ElCard
    },
    name: "formula-create",
    data() {
      return {
        grupos: [],
        errors: {},
        isLoading: false,
        form: {
          descricao: '',
          pergunta_grupo_id: null
        }
      }
    },
    methods: {
      ...mapActions('Pergunta', ['setPergunta']),
      ...mapActions('PerguntaGrupo', ['setList']),
      cancelar() {
        this.$router.push({name: 'pergunta.index'})
      },
      async load() {

        try {
          this.isLoading = true
          this.setList()
        }
        catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      },
      async salvar() {
        this.isLoading = true
        this.errors = []
        try {
          await this.setPergunta({...this.form})
          this.form.descricao = ''
          this.form.pergunta_grupo_id = null
          this.$notify.success("Registro Salvo com sucesso!")
        } catch (error) {
          this.errors = utils.error_form_transform(error)
          if (!this.errors) {
            utils.trataErrors(error)
          }
          console.log(error)
        }
        this.isLoading = false
      }
    },
    computed: {
      ...mapState('PerguntaGrupo', ['list'])
    },
    async mounted() {
      await this.load()
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/features/Pergunta/Create.vue